import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SearchResult} from "../Entity/SearchResult";
import {AppThunk} from "../../app/store";
import {getReadSearchResultsRep} from "../Repository/SearchResultsRepository";
import {Filter} from "../Entity/Filter";

interface SearchResultsState {
  isLoading: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: string | null,
  searchResults: SearchResult[]
}
const searchResultsInitialState: SearchResultsState = {
  isLoading: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  error: null,
  searchResults: []
}

function requestGetSearchResultsStart(state: SearchResultsState) {
  state.isLoading = true;
  state.isRequestFailed = false;
  state.searchResults = [];
}

function requestGetSearchResultsFailed(state: SearchResultsState, action: PayloadAction<string>) {
  state.isLoading = false
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}

function requestGetSearchResultsSuccess(state: SearchResultsState, action: PayloadAction<any>) {
  state.isLoading = false;
  state.error = null;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.searchResults = action.payload;
}

const searchResultsSlice = createSlice({
    name: 'searchResults',
    initialState: searchResultsInitialState,
    reducers: {
      getSearchResultsStart: requestGetSearchResultsStart,
      getSearchResultsSuccess : requestGetSearchResultsSuccess,
      getSearchResultsFailure: requestGetSearchResultsFailed
    }
  }
)

export const {
  getSearchResultsStart,
  getSearchResultsSuccess,
  getSearchResultsFailure,
} = searchResultsSlice.actions;

export default searchResultsSlice.reducer;

export const getSearchResults = (query: string | null = null): AppThunk => async dispatch => {
  try {
    dispatch(getSearchResultsStart())
    const newsApiResponse = await getReadSearchResultsRep(query);
    dispatch(getSearchResultsSuccess(newsApiResponse));
  } catch (err: any) {
    dispatch(getSearchResultsFailure(err.toString()));
  }
}
